import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../components-styles/footer.css';
// import { footerAPI } from '../services/api'; // Uncomment when backend is ready

function Footer() {
  // Note: footerData state can be uncommented when backend endpoints are ready
  const [footerData] = useState(null);

  // Uncomment this useEffect when backend endpoints are ready
  /*
  useEffect(() => {
    const fetchFooterData = async () => {
      setLoading(true);
      try {
        const data = await footerAPI.getFooterData();
        setFooterData(data);
      } catch (error) {
        console.error('Error fetching footer data:', error);
        // Fallback to static data on error
      } finally {
        setLoading(false);
      }
    };
    fetchFooterData();
  }, []);
  */

  // Static fallback data (to be replaced by backend data)
  const staticFooterData = {
    company: {
      name: 'MAGBITY AGENCY LTD',
      description: 'Professional football agency & consultancy services.',
      companyNumber: '16563719'
    },
    quickLinks: [
      { label: 'Home', href: '/' },
      { label: 'Football Agency', href: '/football-agency' },
      { label: 'About', href: '/about' },
      { label: 'Insights', href: '/insights' },
      { label: 'Contact', href: '/contact' }
    ],
    services: [
      { label: 'Player Representation', href: '/football-agency#players' },
      { label: 'Club Services', href: '/football-agency#clubs' },
      { label: 'Project Consultancy', href: '/project-consultancy' },
      { label: 'Market Research', href: '/market-research' }
    ],
    contactInfo: {
      clubEmail: 'emagbity@gmail.com',
      playerEmail: 'emagbity@gmail.com',
      projectEmail: 'emagbity@gmail.com',
      whatsapp: '+447931359023'
    },
    legalLinks: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms & Conditions', href: '/terms-and-conditions' },
      { label: 'FAQ', href: '/faq' },
      { label: 'Cookie Policy', href: '/privacy-policy' }
    ],
    compliance: 'FIFA & FA Licensed • FA Approved • Professional Standards • England & Wales Jurisdiction',
    copyright: '© 2026 MAGBITY AGENCY. All rights reserved. Magbity Agency is licensed under FIFA FFAR regulations.'
  };

  const data = footerData || staticFooterData;

  return (
    <footer className="footer">
      <div className="footer-content">
        
        {/* Main Footer Sections */}
        <div className="footer-sections">
          <div className="footer-section">
            <h3>{data.company.name}</h3>
            <p>{data.company.description}</p>
            <p className="company-details">England & Wales ({data.company.companyNumber})</p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              {data.quickLinks.map((link, idx) => (
                <li key={idx}><a href={link.href}>{link.label}</a></li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Services</h3>
            <ul>
              {data.services.map((service, idx) => (
                <li key={idx}><a href={service.href}>{service.label}</a></li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact</h3>
            <ul>
              <li>
                <strong>Club Enquiries:</strong><br/>
                <a href={`mailto:${data.contactInfo.clubEmail}`}>{data.contactInfo.clubEmail}</a>
              </li>
              <li>
                <strong>Player Enquiries:</strong><br/>
                <a href={`mailto:${data.contactInfo.playerEmail}`}>{data.contactInfo.playerEmail}</a>
              </li>
              <li>
                <strong>Services:</strong><br/>
                <a href={`mailto:${data.contactInfo.projectEmail}`}>{data.contactInfo.projectEmail}</a>
              </li>
              <li>
                <strong>WhatsApp:</strong><br/>
                <a href={`https://wa.me/${data.contactInfo.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer">{data.contactInfo.whatsapp}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Legal & Bottom Footer */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <ul>
              {data.legalLinks.map((link, idx) => (
                <li key={idx}><Link to={link.href}>{link.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="footer-compliance">
            <p>{data.compliance}</p>
          </div>

          <div className="footer-copyright">
            <p>{data.copyright}</p>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
